import * as channelsPack from './channels/index.js';
import * as platformsPack from './platforms/index.js';

export const channels = channelsPack;
export const platforms = platformsPack;
export const all = {
  ...channelsPack,
  ...platformsPack,
};
